export const HEADER_LOGO = "HEADER_LOGO";
export const RECURRING_MODEL_CHECK = "RECURRING_MODEL_CHECK";
export const SET_RECURRING_MODEL_CHECK = "SET_RECURRING_MODEL_CHECK";
export const SET_SELECTED_BATCH_ID = "SET_SELECTED_BATCH_ID";
export const MODAL_CLOSE_VALUE = "MODAL_CLOSE_VALUE";